import { Box, Grid2 } from '@mui/material';
import CustomTypography from '@ui-components/Typography/CustomTypography';
import CustomAvatar from '@ui-components/Avatar/CustomAvatar';
import './profile.css';

const userName = localStorage.getItem('username')?.charAt(0).toUpperCase();

const UserProfile = () => {
  return (
    <Box className="pt-20  text-align-left">
      <CustomTypography id="profile-title" variant="h4" className="pb-32">
        Profile
      </CustomTypography>
      <Grid2 container spacing={4}>
        <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
          <Box className="text-align-left bg-white p-24 profile-container">
            <Box>
              <CustomTypography id="edit-profile-title" variant="h5">
                User Profile
              </CustomTypography>
            </Box>
            <Box className="p-32 flex align-items-center">
              <Grid2 container spacing={4} className="width-100">
                <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                  <CustomAvatar
                    id="user-profile-avatar"
                    alt={userName}
                    src="/static/images/avatar/2.jpg"
                    width={72}
                    height={72}
                    className="mr-20 profile-image-alt"
                  ></CustomAvatar>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}>
                  <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Box className="pb-32">
                      <CustomTypography
                        id="profile-name"
                        variant="body3"
                        className="pb-12"
                        color="textDisabled"
                      >
                        Name
                      </CustomTypography>
                      <CustomTypography
                        id="name-text"
                        variant="body3"
                        color="textPrimary"
                      >
                        Vamsi
                      </CustomTypography>
                    </Box>
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Box className="pb-32">
                      <CustomTypography
                        id="profile-email"
                        variant="body3"
                        className="pb-12"
                        color="textDisabled"
                      >
                        Email
                      </CustomTypography>
                      <CustomTypography
                        id="email-text"
                        variant="body3"
                        color="textPrimary"
                      >
                        Vamsik@boston-technology.com
                      </CustomTypography>
                    </Box>
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Box>
                      <CustomTypography
                        id="profile-phone"
                        variant="body3"
                        className="pb-12"
                        color="textDisabled"
                      >
                        Phone
                      </CustomTypography>
                      <CustomTypography
                        id="phone-text"
                        variant="body3"
                        color="textPrimary"
                      >
                        1234567890
                      </CustomTypography>
                    </Box>
                  </Grid2>
                </Grid2>
              </Grid2>
            </Box>
            {/* <CustomButton
                id="upload-profile"
                variant="contained"
                color="primary"
              >
                Upload
              </CustomButton>
              <Box className="pl-12">
                <CustomIconButton
                  id="delete-profile"
                  icon={<DeleteIcon />}
                ></CustomIconButton>
              </Box> */}
            <Box className="pt-32 pb-32"></Box>
            {/* <Box className="pt-32 text-align-right">
              <CustomButton
                id="save-profile"
                variant="contained"
                color="primary"
              >
                Save Changes
              </CustomButton>
            </Box> */}
          </Box>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default UserProfile;
